<div class="container-fluid gx-0 d-flex flex-column min-vh-100 app-bg-color">
<app-header-new></app-header-new>
 <div class="row gx-0 flex-grow-1" >
    <div class="col content">
     

<div class="landing-container">
  <div class="container">
    <div class="landing-content">
      <div class="service-cards">
        <div 
          *ngFor="let item of landingOptions" 
          class="service-card"
          (click)="toggleExpand(item)">
          
          <div class="card-main">
            <div class="card-content">
              <h3 class="card-title">{{ item.title }}</h3>
              <p class="card-subtitle">{{ item.subtitle }}</p>
            </div>
            
            <div class="card-action">
               <img
                      src="../../../../assets/images/paylife-right-arrow.svg" alt="icon"
                      class="arrow-icon ms-auto"
                    />
            </div>
          </div>
        </div>
         <div class="mt-40 ">
            <app-bottom-nav (backClicked)="onBack()" nextCaption="Weiter" [nextHidden]="true">
            </app-bottom-nav>
        </div>
      </div>
     
    </div>
     
  </div>


</div>


    </div>
  </div>
<app-footer></app-footer>
</div>